'use client';

import { useEffect } from 'react';
import { captureException } from '@sentry/nextjs';
import { ErrorScreen } from '@/components/system/ErrorScreen';

export default function AppError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    captureException(error);
  }, [error]);

  return <ErrorScreen onRetry={reset} />;
}
